/**
 * FLIGHT CONTROLLER BOOT SEQUENCE // KEVIN ARTHUR DE LIMA
 * 1.2s flight check boot sequence with mono progress log. Skippable & session cached.
 */

export function runBootSequence(onComplete) {
  const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasBooted = sessionStorage.getItem('kadl_boot_v2') === 'true';

  if (isReducedMotion || hasBooted) {
    if (onComplete) onComplete();
    return;
  }

  const bootEl = document.createElement('div');
  bootEl.id = 'boot-sequence';
  bootEl.innerHTML = `
    <div class="boot-box">
      <div class="mono-label" style="margin-bottom: 12px; color: var(--mute);">SYS-BOOT // AUTONOMOUS AVIONICS INITIALIZATION</div>
      <div class="boot-log" id="boot-log-content"></div>
      <div class="boot-progress-track">
        <div class="boot-progress-bar" id="boot-bar"></div>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span class="mono-label" id="boot-status">INITIALIZING...</span>
        <button class="boot-skip-btn" id="boot-skip">[ ESC / SKIP BOOT ]</button>
      </div>
    </div>
  `;
  document.body.appendChild(bootEl);

  const logEl = document.getElementById('boot-log-content');
  const barEl = document.getElementById('boot-bar');
  const statusEl = document.getElementById('boot-status');
  const skipBtn = document.getElementById('boot-skip');

  const steps = [
    { text: "INIT FLIGHT CONTROLLER (NAVIO2 LINUX)...", delay: 150 },
    { text: "CALIBRATING BMI160 IMU NOISE FILTER... OK", delay: 350 },
    { text: "READING TELEMETRY (ESP-NOW 2.4GHz / MAVLINK)... OK", delay: 650 },
    { text: "LOADING PROCEDURAL AIRFRAME SCHEMATIC... OK", delay: 900 },
    { text: "FLIGHT SYSTEMS ARMED. READY.", delay: 1200 }
  ];

  let completed = false;

  function finish() {
    if (completed) return;
    completed = true;
    sessionStorage.setItem('kadl_boot_v2', 'true');
    bootEl.style.transition = 'opacity 0.3s ease';
    bootEl.style.opacity = '0';
    setTimeout(() => {
      if (bootEl.parentNode) bootEl.parentNode.removeChild(bootEl);
      if (onComplete) onComplete();
    }, 300);
  }

  skipBtn.addEventListener('click', finish);
  window.addEventListener('keydown', e => {
    if (e.key === 'Escape') finish();
  });

  steps.forEach((step, idx) => {
    setTimeout(() => {
      if (completed) return;
      const line = document.createElement('div');
      line.className = 'boot-log-line';
      line.textContent = step.text;
      logEl.appendChild(line);

      const progress = Math.round(((idx + 1) / steps.length) * 100);
      barEl.style.width = `${progress}%`;
      statusEl.textContent = `${progress}% VERIFIED`;

      if (idx === steps.length - 1) {
        setTimeout(finish, 250);
      }
    }, step.delay);
  });
}
